import React from 'react';

import { Parallax } from 'react-parallax';

const ParallaxSection = (props) => {
	// Props Destructuring
	const {
		background,
		height,
		image,
		imageAlt,
		sectionTitleLine1,
		sectionTitleLine2,
		titleFontConfig,
	} = props;

	return (
		<Parallax
			bgImage={image}
			bgImageAlt={imageAlt}
			strength={-200}
			style={{ width: '100%', height: '100%' }}>
			<div
				className='d-flex aligin-items-center justify-content-center'
				style={{ height: height, backgroundColor: background }}>
				<h1
					className='parallax-title d-flex align-items-center justify-content-center text-center'
					style={titleFontConfig}>
					{sectionTitleLine1}
					<br />
					{sectionTitleLine2}
				</h1>
			</div>
		</Parallax>
	);
};

export default ParallaxSection;
